angular.module("rightPaneModule")
  .directive("editTeacherData", ['authentication', function($authentication) {
    return {
      restrict: "E",
      templateUrl: '/resources/right-pane/partials/edit-teacher-data.html',
      scope: {
        teacherData: '=',
        settings: '=',
        settingsForm: '=',
        schoolsList: '=',
        classroomList: '=',
        onSchoolSelected: '='
      },
      link : function($scope, $elem, $attr) {
        $scope.teacherRoles = [
          {type: 'Teacher', name: 'Teacher'},
          {type: 'SchoolAdmin', name: 'School Administrator'}
        ];
        var customer = $authentication.getCustomer();
        if ($authentication.isDistrictAdmin(customer)) {
          $scope.teacherRoles.push({type: 'DistrictAdmin', name: 'District Administrator'});
        }

        function updateClassroomsElementValidity() {
            var classroomsElement = $scope.settingsForm.classrooms;
            if (classroomsElement) {
                var isAdmin = $scope.teacherData.role !== 'Teacher';
                var classroomAssigned = $scope.teacherData.classrooms.length > 0;
                classroomsElement.$setValidity("noclassrooms", isAdmin || classroomAssigned);
            }
        }
        $scope.$watch('teacherData.classrooms.length', updateClassroomsElementValidity);
        $scope.$watch('teacherData.role', updateClassroomsElementValidity);
      }
    };
  }]);
